import React from 'react';
import styled from 'styled-components';
import { Typography, TypographyProps } from '../Typography';

export const CardHeaderTitle = styled(({ children, ...other }: Omit<TypographyProps, 'variant'>) => (
    <Typography variant='h6' {...other}>
        {children}
    </Typography>
))`
    ${() => `
        && {
            font-weight: 600;
        }
    `}
`;